export interface RoleState {
    role: any;
  }
  
  export const roleStateConfig = {
    initState: {
      role: null,
    }
  }
  
  